import { REQUEST_ADDRESS_REL, REQUEST_ADDRESS_BY_KEY_REL } from './constants'

export const searchAddressRelSelector = (state) =>
  state.links.filter((link) => link.Rel === REQUEST_ADDRESS_REL)[0]
export const searchAddressByKeyRelSelector = (state) =>
  state.links.filter((link) => link.Rel === REQUEST_ADDRESS_BY_KEY_REL)[0]

export const getPostcode = (state) => state.address.Postcode
